import { toFormData } from '../lib/utils/forms';
import { axiosAPI } from './axios-instance';
import { ApiResponse } from './lib/types';

export type ApiPostQuestionRequest = {
    name: string;
    email: string;
    email_to?: string;
    phone: string;
    message?: string;

    //для АМО
    url?: string;
    utm_source?: string;
    utm_medium?: string;
    utm_campaign?: string;
    utm_term?: string;
    utm_content?: string;
};

export type ApiPostQuestionResponse = ApiResponse<{
    message: string;
}>;

export type AppPostQuestionResponse = ApiResponse<{
    message: string;
}>;

const transformApiResponse = (response: ApiPostQuestionResponse): AppPostQuestionResponse => {
    return response;
};

export const postQuestion = (body: ApiPostQuestionRequest): Promise<AppPostQuestionResponse> =>
    axiosAPI
        .post<ApiPostQuestionResponse>('/v1/feedback/question', toFormData(body))
        .then((res) => transformApiResponse(res.data));
